var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(5 5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.7522 8.10571C7.26405 8.59386 7.26405 9.38532 7.7522 9.87348L13.0555 15.1768L7.92898 20.3033C7.44082 20.7915 7.44082 21.5829 7.92898 22.0711C8.41713 22.5592 9.20859 22.5592 9.69674 22.0711L14.8233 16.9445L20.1266 22.2478C20.6147 22.736 21.4062 22.736 21.8943 22.2478C22.3825 21.7597 22.3825 20.9682 21.8943 20.4801L16.591 15.1768L22.0711 9.6967C22.5593 9.20854 22.5593 8.41709 22.0711 7.92893C21.583 7.44078 20.7915 7.44078 20.3033 7.92893L14.8233 13.409L9.51997 8.10571C9.03181 7.61755 8.24036 7.61755 7.7522 8.10571Z",
    fill: "#1513C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/CloseModal.ae8437367c223a2cf8c1f8c61ac9c9e0.svg";
export { ForwardRef as ReactComponent };